import React from 'react';
import { connect } from 'react-redux';
import util from '../../../lib/util';
import CheckBox from '../../Basic/CheckBox';
import Select from '../../Basic/Select';
import RadioSection from '../../Sections/RadioSection';
import FortisButton from '../../Basic/FortisButton';
import DuplexBuilding from './DuplexBuilding';
import NewGasLineAvailable from './NewGasLineAvailable';
import LinkButton from '../../Basic/LinkButton';
import { selectedAddress, duplexAddress } from '../../../selectors/ServiceAddress';
import { nextStepClicked } from '../../../actions';
import { Address2Validation } from '../Address2';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';

class CheckAvailibility extends React.Component {
   
    componentWillReceiveProps(newProps) {
        if (newProps.checkConfirmAddress == 1 && !newProps.isResume) {
            if (newProps.addressList == -1 || newProps.addressList == -2) {
                let validators = [['addressList', p => p.addressList != -2, "Address"]];
                if (newProps.addressList == -1)
                    validators = [...validators, ...Address2Validation('siteAddress')];
                if (!util.validate(validators, newProps, newProps.formError)) {
                    newProps.dispatch({ type: 'checkbox', name: 'checkConfirmAddress', value: 0 });
                }
            }
        }
    }
    onCheckAvailibilityClick = () => {
        const p = this.props;
        const validatorMessages = window.osa.lookup.validation;
        let validators = [['buildingCondition', p => p.buildingCondition]];
        if (p.buildingType === "2" && p.duplexMeterCount === "2") {
            validators = [...validators,
            ['duplexSecondAddress_unitNumber',
                p => (p.address1.unitNumber != p.duplexSecondAddress_unitNumber) || (p.address1.streetNumber != p.duplexSecondAddress_streetNumber),
                "#" + validatorMessages.duplexUniqueAddress]
            ];
        }
        //buildingCondition
        if (util.validate(validators, p, p.formError)) {
            //util.trackGoogleAnalytics(1, 'Service address', 'Without offramp');         
            const address = {
                unitNumber: p.address1.unitNumber,
                streetNumber: p.address1.streetNumber,
                streetName: p.address1.streetName,
                poBox: p.address1.poBox,
                postCode: p.address1.postCode,
                streetType: { id: 0, name: p.address1.streetType, sortOrder: 0 },
                city: { id: 0, name: p.address1.city, sortOrder: 0 },
                province: { id: 0, name: p.address1.province, sortOrder: 0 },
                country: { id: 0, name: p.address1.country, sortOrder: 0 },
                coordinate: { id: 0, lat: 0, lng: 0 },
                addressType: { id: 0, name: "Project Address1", sortOrder: 0 },
                addressSubType: { id: 0, name: null, sortOrder: 0 },
                streetDirection: { id: 0, name: p.address1.streetDirection, sortOrder: 0 }
            };
            let model = {
                siteAddress: p.address1,
                buildingInfo: util.getNamebyId(window.osa.lookup.serviceAddress.buildingType.items,p.buildingType),
                isDuplexWith2Meters: p.buildingType == "2" && p.duplexMeterCount === "2",
                isAddressManuallyEntered: p.addressList == -1,
                address
            };
            p.dispatch({ type: "CHECK_AVAILIBILITY", model });
            //p.onNextStepClicked(1);
        }
    }
    onNextClick = () => {
        this.props.onNextStepClicked(1);
    }
    render() {
        const p = this.props;
        if (p.addressList == undefined) return null;
        const serviceAddress = window.osa && window.osa.lookup && window.osa.lookup.serviceAddress;
        return (
            <div>
                <CheckBox name="checkConfirmAddress" title={serviceAddress && serviceAddress.confirmAddress} />
                {
                    p.checkConfirmAddress ?
                        <div>
                            <RadioSection name="buildingCondition" {...serviceAddress.buildingCondition} required />
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Select name="buildingType" {...serviceAddress.buildingType} customClass="col-sm-4" />
                                    </div>
                                </div>
                            </div>
                            {
                                p.buildingType === "2" ? <DuplexBuilding address={p.isResume ? p.address2 : p.address1} duplexMeterCount={p.duplexMeterCount} /> : null
                            }
                            <FortisButton text="Check availability" onClick={this.onCheckAvailibilityClick} />
                        </div>
                        : null
                }
                {
                    (p.serviceCost && !p.offramp) ?
                        <div>
                            <br />
                            <br />
                            <div className="row">
                                <div className="col-sm-12">
                                    <NewGasLineAvailable address1={p.address1} serviceCost={p.serviceCost} address2={p.address2} isTwoMeter={p.isTwoMeter} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                <ButtonToolbar style={{display: "inline-flex"}}>
                                    <FortisButton text={serviceAddress && serviceAddress.available && serviceAddress.available.nextButtonText} onClick={this.onNextClick} />
                                    <LinkButton text="Cancel" onClick={p.onCancelClick} />
                                    </ButtonToolbar>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <b style={{ paddingTop: '10px' }}>{serviceAddress && serviceAddress.available &&  serviceAddress.available.haveQuestion}</b>
                                </div>
                                <div className="col-sm-12">
                                    <p style={{ paddingTop: '10px' }} dangerouslySetInnerHTML={{ __html: window.osa.lookup && window.osa.lookup.common && window.osa.lookup.common.contactUsPhoneTextStandalone }} />
                                </div>
                            </div>
                        </div>
                        : null
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        addressList: state.form.addressList,
        checkConfirmAddress: state.form.checkConfirmAddress,
        buildingType: state.form.buildingType,
        buildingCondition: state.form.buildingCondition,
        duplexMeterCount: state.form.duplexMeterCount,
        address1: selectedAddress(state),
        address2: duplexAddress(state),
        duplexSecondAddress_unitNumber: state.form.duplexSecondAddress_unitNumber,
        duplexSecondAddress_streetNumber: state.form.duplexSecondAddress_streetNumber,
        serviceCost: state.gas.serviceCost,
        offramp: state.gas.offramp,
        siteAddress_streetNumber: state.form.siteAddress_streetNumber,
        siteAddress_streetName: state.form.siteAddress_streetName,
        siteAddress_city: state.form.siteAddress_city,
        siteAddress_country: state.form.siteAddress_country,
        siteAddress_state: state.form.siteAddress_state,
        siteAddress_zip: state.form.siteAddress_zip,
        isResume : state.gas.isResume,
        isTwoMeter: state.form.buildingType == "2" && state.form.duplexMeterCount == "2",
    };
};
function mapDispatchToProps(dispatch) {
    return {
        onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error })       
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CheckAvailibility);